module.exports = __webpack_public_path__ + "img/con3_return_visit2.365b5d7d.png";